import { Component } from "react";
import { AppBar, Dialog, DialogContent, IconButton, Toolbar, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Zoom from "../../Basics/Zoom";
import Annotation from "react-image-annotation";

class FormImageField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.metaQuestion.descriptive_image,
            title: this.props.metaQuestion.question,
            previewImage: false,
        };
    }

    preview() {
        this.setState({ previewImage: true });
    }

    closePhotoPreview() {
        this.setState({
            previewImage: false,
        });
    }

    render() {
        return (
            <div className="full_size control-margin-top">
                <img
                    src={"data:image/png;base64, " + this.state.value}
                    alt={this.state.title}
                    style={{ width: "100%" }}
                    onClick={this.preview.bind(this)}
                />
                <Dialog fullScreen open={this.state.previewImage} onClose={this.closePhotoPreview.bind(this)}>
                    <AppBar>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.closePhotoPreview.bind(this)} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit">
                                {this.state.title}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Toolbar />
                    <DialogContent className="without-side-padding container-with-footer">
                        <Zoom>
                            <div
                                style={{
                                    maxWidth: "1920px",
                                    maxHeight: "1920px",
                                }}
                            >
                                <Annotation
                                    src={"data:image/png;base64, " + this.state.value}
                                    annotations={[]}
                                    disableOverlay={true}
                                    disableEditor={true}
                                    disableSelector={true}
                                    disableAnnotation={true}
                                />
                            </div>
                        </Zoom>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

export default FormImageField;
